<template>
  <div>
    <div class="mask flex flex-center flex-center-2">
      <div class="flex column flex-center relative">
        <img src="../../page/daysurgery/assets/picc.png" alt="" :style="imgStyle">
        <p class="close mt10">
          <font class="iconfont fs50 color_bbb" @click="close">&#xe61a;</font>
        </p>
        <div class="topicc absolute" :style="piccStyle" @click="onClick('confirm')"></div>
        <!--        <div class="call absolute" :style="callStyle" @click="onClick('call')"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";

export default {
  name: "ds-to-picc",
  components: {VTabs},
  data() {
    return {
      baseW: 80,
      delta: 930 / 1071,
      showTag: false,
      type: '',
    }
  },
  computed: {
    imgStyle() {
      return {
        width: `${this.baseW}vw`,
        height: `${this.baseW / this.delta}vw`
      }
    },
    piccStyle() {
      return {
        left: `${59 / 620 * this.baseW}vw`,
        right: `${59 / 620 * this.baseW}vw`,
        top: `${528 / 734 * (this.baseW / this.delta)}vw`,
        height: `${80 / 734 * (this.baseW / this.delta)}vw`,
      }
    },
    callStyle() {
      return {
        left: `${59 / 620 * this.baseW}vw`,
        right: `${59 / 620 * this.baseW}vw`,
        top: `${(528 + 80) / 734 * (this.baseW / this.delta)}vw`,
        height: `${126 / 734 * (this.baseW / this.delta)}vw`,
      }
    }
  },
  watch: {
    showTag() {
      this.showTag === false && this.onClosed();
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    },
    onChange(data) {
      this.currTab = data.label;
      Log('data', data);
    }
  },
}
</script>

<style scoped lang="scss">
.mask {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
}

.topicc {
  background-image: url("../../../src/page/daysurgery/assets/toppic.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/ds-to-picc.vue